import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/base/base-form.component';
import { AuthService } from '../../../../core/auth.service';
import { LoadingService } from '../../../../core/loading.service';
import { DialogService, Dialog } from '../../../../core/dialog.service';
import { AlertService } from '../../../../core/alert.service';
import { UtilityService } from '../../../../core/utility.service';
import { TranslatorService } from '../../../../core/translator.service';
import { OptionsSource } from '../../../../core/core.models';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/shared/base/base.service';
import { Constants } from 'src/app/app.constants';
import { User, UserType } from '../../users/users.models';
import { ValueLabel } from 'src/app/shared/base/base.models';
import { CompaniesService } from '../../companies/companies.service';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-customers-form',
  templateUrl: './customers-form.component.html',
  styleUrls: ['./customers-form.component.scss']
})
export class CustomersFormComponent extends BaseFormComponent implements OnInit {
  public companies: OptionsSource;
  public userTypes: ValueLabel[] = [];
  public unclassified: string;

  public isCurrentUserSystem: boolean = false;
  public isSystemUser: boolean = false;
  public myUser: boolean = false;
  public activeText: string;

  public keyRole: string = 'CLIENT_CUSTOMER';

  constructor(
    private companiesService: CompaniesService,
    private translateService: TranslateService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService
  ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService);
  }

  ngOnInit(): void {
    this.authorities.init('C_USR', 'R_USR', 'U_USR', null);

    this.url = `${Constants.contextPath}/${this.id ? 'users' : 'registrations/create-user'}`;
    this.prepareLookupData();
    this.prepareFormData(new User(), (response: User) => {
      return this.modifyResponse(response);
    });
  }

  public modifyResponse(response: User) {
    response.breadcrumbsId = response.name;
    this.isSystemUser = response.userType == UserType[UserType.SYSTEM];
    this.myUser = response.id == this.authService.userId;
    this.active = response.active;
    this.activeText = response.active ? 'SHARED.DEACTIVATE' : 'SHARED.ACTIVATE';
    if (!this.isSystemUser)
      this.companies = this.companiesService.getCompaniesOptions();
    return response;
  }

  private prepareLookupData() {
    this.isCurrentUserSystem = this.authService.userType == UserType[UserType.SYSTEM];
    this.userTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(UserType, true), 'value', 'label', 'ENUMS.USER_TYPES.');

    if(!this.isCurrentUserSystem) {
      let index = this.userTypes.findIndex(u => u.value == UserType[UserType.SYSTEM]);
      if(index > -1) {
        this.userTypes.splice(index, 1);
      }
    }
  }
}
